import humps from 'humps';

export default function PostCreativeTagData(
  $location,
  CreativeService,
  RenderService,
  CurrentPartnerService
) {
  const vm = this;

  vm.buildMediaUrl = buildMediaUrl;
  vm.buildPostMessage = buildPostMessage;
  CurrentPartnerService.get().then(partner => {
    vm.partner = partner;
  });

  function buildMediaUrl(creative) {
    if (creative.mediaUrl) {
      if (creative.mediaUrl.match(/^\/article_content/)) {
        return `${creative.generatorUrl || ''}${creative.mediaUrl}`;
      } else {
        return creative.mediaUrl;
      }
    } else if (creative.vastTag) {
      return '';
    } else if (creative.action === 'hosted-video') {
      return 'https://legacy-design-assets.s3.amazonaws.com/videos/video-play-here.mp4';
    } else {
      return '';
    }
  }

  function getCreativeAction(action) {
    if (action === 'outstream') {
      return 'hosted-video';
    }

    // This makes instream videos render using the VAST tag
    if (action === 'instream-video') {
      return 'hosted-video';
    }

    return action || 'clickout';
  }

  function getDealId() {
    const queryParam = $location.search().dealId;
    if (queryParam) {
      return queryParam;
    } else if (vm.partner.partnerType === 'Enhanced Ads') {
      return 'BJ9B5';
    } else {
      return;
    }
  }

  function getBehaviors() {
    let behaviors = [];
    const queryBehaviors = $location.search().behaviors;
    if (queryBehaviors) {
      behaviors = behaviors.concat(queryBehaviors);
    }
    if (getDealId() === 'BJ9B5') {
      behaviors = behaviors.concat('shouldContainThumbnail');
    }
    return behaviors;
  }

  function sanitizedAdm(adm) {
    if (!adm) {
      return adm;
    }

    return adm
      .replace(/\\n/g, '\n')
      .replace(/\\r/g, '')
      .replace(/\\/g, '');
  }

  function buildPostMessage(type, topScrollOffset, scrollToAdUnit = true) {
    const data = CreativeService.creativeWithDefaults();
    const postMessage = {
      type: type,
      topScrollOffset,
      scrollToAdUnit,
      isContentCard: false,
      content: {
        uid: 'demoUserId',
        placement: {
          layout: 'single',
          status: 'pre-live',
          articles_before_first_ad: null,
          articles_between_ads: null,
          placementAttributes: {
            template: '<div>Foo!</div>',
            hasCustomTemplate: true,
            backfillTag: null,
            promoted_by_text: 'Ad by',
            allow_dynamic_cropping: RenderService.site.dynamicCroppingEnabled,
            strOptOutUrl:
              'https://platform-cdn.sharethrough.com/privacy-policy',
            customCardCss: '::-webkit-scrollbar {display: none !important;}'
          },
          allowInstantPlay: true,
          metadata: {
            experiment: {
              script_url: null,
              block_rendering: false
            }
          }
        },
        creatives: [
          {
            creative: {
              force_click_to_play: data.creative.forceClickToPlay,
              instant_play: data.creative.instantPlay,
              creative_key: 'demoCreativeKey0',
              advertiser: data.creative.advertiser,
              title: data.creative.headline,
              description: data.creative.description,
              thumbnail_url: data.creative.thumbnailUrl || '',
              original_thumbnail_url: data.creative.thumbnailUrl || '',
              media_url: buildMediaUrl(data.creative),
              vast_url: data.creative.vastTag || '',
              custom_engagement_url: data.creative.customEngagementUrl,
              custom_engagement_label: data.creative.customEngagementLabel,
              autoplayJson: data.creative.autoplayJson,
              action: getCreativeAction(data.creative.action),
              impression_html: data.creative.impressionHtml,
              slides: humps.decamelizeKeys(data.creative.slides) || [],
              slideshow_autoscroll: data.creative.slideshowAutoscroll,
              scroll_direction: data.creative.scrollDirection,
              icon_url: data.creative.iconUrl,
              adm: sanitizedAdm(data.creative.adm),
              deal_id: getDealId(),
              brand_logo_url: data.creative.brandLogoUrl,
              srt: data.creative.srtFileUrl || '',
              isi: {
                text: data.creative.isiText,
                autoscroll: data.creative.isiAutoscroll
              },
              beacons: {
                visible: [],
                click: [],
                play: [],
                impression: []
              },
              behaviors: getBehaviors()
            }
          }
        ]
      }
    };

    if (data.creative.action === 'hosted-video') {
      const postCreative = postMessage.content.creatives[0].creative;
      postCreative.video_aspect_ratio = data.creative.videoAspectRatio;
    }

    return JSON.stringify(postMessage);
  }
}

PostCreativeTagData.$inject = [
  '$location',
  'CreativeService',
  'RenderService',
  'CurrentPartnerService'
];
